import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import AnimatedNumber from "./AnimatedNumber";
import Sparkline from "./Sparkline";

export default function KpiCard({ k, index = 0 }) {
  const Icon = Icons[k.icon] || Icons.Activity;
  const isRisk = k.label.toLowerCase().includes("risk") || k.label.toLowerCase().includes("violation");
  const isUp = k.trend === "up";
  const positive = isRisk ? !isUp : isUp;
  const deltaColor = positive ? "#22C55E" : "#EF4444";
  const sparkColor = positive ? "#22C55E" : isRisk ? "#EF4444" : "#5B8DEF";

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, delay: 0.04 * index, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link
        to={`/explore/${k.key}`}
        data-testid={`kpi-${k.key}`}
        className="card-eco card-eco-hover block p-5"
      >
        <div className="flex items-start justify-between">
          <div>
            <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-400">
              {k.label}
            </div>
            <div className="mt-3 font-mono text-3xl font-light tracking-tight text-white">
              <AnimatedNumber value={k.value} />
            </div>
          </div>
          <div className="rounded-lg border border-white/5 bg-white/[0.03] p-2">
            <Icon size={16} className="text-slate-300" strokeWidth={1.6} />
          </div>
        </div>
        <div className="mt-3 flex items-end justify-between">
          <div className="flex items-center gap-2">
            <span className="font-mono text-[11px]" style={{ color: deltaColor }}>
              {k.delta}
            </span>
            <span className="text-[11px] text-slate-500">vs last 7d</span>
          </div>
          {k.spark && <Sparkline data={k.spark} color={sparkColor} width={70} height={24} />}
        </div>
      </Link>
    </motion.div>
  );
}
